import { Navigate, useParams } from 'react-router-dom';
import { sampleById } from '@/data/samples';
import { sampleWorkspaceHref } from '@/lib/messageWorkspace';
import { NotFoundView } from './NotFoundView';

/** Legacy /samples/:sampleId → message workspace with ?sample=. */
export function SampleRedirect() {
  const { sampleId } = useParams();
  const sample = sampleId ? sampleById(sampleId) : undefined;
  if (!sample) return <NotFoundView />;
  const href = sampleWorkspaceHref(sample.id);
  if (!href) return <NotFoundView />;
  return <Navigate to={href} replace />;
}
